import React from 'react'
import PropTypes from 'prop-types'
import StatusBadge from 'components/atoms/status-badge'
import { PHOTOGRAPHY_STATUS } from 'domains/merchant-product/constants'

const propTypes = {
  photographyStatus: PropTypes.string.isRequired
}

/**
 * To give nice look on Merchant Product `photograohy_status`.
 * It maps `curation_status` to certain style and pass to `StatusBadge`.
 * @param {string} photographyStatus
 */
const MerchantProductPhotographyStatusBadge = ({ photographyStatus }) => {

  const colorMap = {
    [PHOTOGRAPHY_STATUS.PENDING]   : 'warning',
    [PHOTOGRAPHY_STATUS.COMPLETED] : 'success'
  }

  const color = colorMap[photographyStatus] || 'default'

  return <StatusBadge color={ color } label={ photographyStatus } />
}

MerchantProductPhotographyStatusBadge.propTypes = propTypes

export default MerchantProductPhotographyStatusBadge
